import {AdminCollars, AdminTraps, AdminDropOffs, AdminExternalSensors, AdminCameras, AdminConfigurationDevices, AdminDataLoggers, AdminTT4Sensors} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AdminItemsServices {
  constructor(
    public collar: AdminCollars,
    public trap: AdminTraps,
    public dropOff: AdminDropOffs,
    public externalSensor: AdminExternalSensors,
    public camera: AdminCameras,
    public configurationDevice: AdminConfigurationDevices,
    public dataLogger: AdminDataLoggers,
    public tt4Sensor: AdminTT4Sensors,
  ) {}
}